var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useCFOptions } from '@connectrn/ds-ui-base';
import { CFCheckbox, CFContainer, CFFieldElements } from '../../components';
import { commonAttrs } from '../../utils';
export const CFCheckboxField = (_a) => {
    var { disabled = false, name, onChange, options, 
    // validationState = 'default',
    value = '' } = _a, rest = __rest(_a, ["disabled", "name", "onChange", "options", "value"]);
    const { FieldToggleOptionLabel, FieldToggleOptionContainer } = CFFieldElements;
    const { options: internalOptions, updateFromSelection } = useCFOptions({
        allowMultiple: true,
        initialOptions: options,
        initialValue: value,
        onChange,
    });
    const onFieldChange = (selection) => {
        updateFromSelection(selection);
    };
    return (React.createElement(CFContainer, Object.assign({}, commonAttrs(rest)), internalOptions === null || internalOptions === void 0 ? void 0 : internalOptions.map(({ id, label, selected, value }, i) => {
        const fieldKey = `checkbox-field-${name}-option-${id}-${i.toString()}`;
        const testID = rest.testID
            ? `${rest.testID}-option-${id}`
            : undefined;
        return (React.createElement(FieldToggleOptionContainer, { key: fieldKey, htmlFor: fieldKey },
            React.createElement(CFCheckbox, { checked: selected, disabled: disabled, id: fieldKey, name: name, key: fieldKey, onChange: (checked) => onFieldChange({ selected: checked, value }), testID: testID, value: value }),
            React.createElement(FieldToggleOptionLabel, null, label || value)));
    })));
};
